import { Injectable } from '@angular/core';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';
import { AbstractControl } from '@angular/forms';
import { KeyValuePair } from '@sb-tools/typescript/models/key-value-pair.model';

@Injectable({ providedIn: 'root' })
export class FieldsSearchService {
    constructor(private windowRef: WindowRef) {}

    checkValidation(controls: { [key: string]: AbstractControl }): boolean {
        const fieldsControls = [];

        for (const control in controls) {
            if (Object.prototype.hasOwnProperty.call(controls, control) && control.includes('fieldElement')) {
                fieldsControls.push(controls[control]);
            }
        }

        const checkedFormElementTypes = [FieldType.checklist, FieldType.date, FieldType.address];

        let isValid = true;
        checkedFormElementTypes.forEach((type) => {
            fieldsControls.find((control) => {
                if (
                    control.value.fieldKey &&
                    control.value.fieldKey.type === type &&
                    control.value.fieldKey.isRequired &&
                    !(control.value.fieldKey.value && control.value.fieldKey.value.length)
                ) {
                    isValid = false;
                }
            });
        });

        return isValid;
    }

    getEncodedValue(fieldsList: KeyValuePair[] | string): string {
        return this.windowRef.nativeWindow.btoa(unescape(encodeURIComponent(JSON.stringify(fieldsList))));
    }

    getEncodedValueFromControls(controls: { [key: string]: AbstractControl }): KeyValuePair[] | string {
        const fieldsList: KeyValuePair[] = this.getFieldValue(controls);

        if (fieldsList?.length) {
            return this.getEncodedValue(fieldsList);
        }
        return null;
    }

    getFieldValue(controls: { [key: string]: AbstractControl }): KeyValuePair[] {
        const fieldsControls = [];
        const fieldsValues = [];

        for (const control in controls) {
            if (Object.prototype.hasOwnProperty.call(controls, control) && control.includes('fieldElement')) {
                fieldsControls.push(controls[control]);
            }
        }

        fieldsControls.forEach((control) => {
            if (control.value.fieldKey) {
                fieldsValues.push({
                    key: control.value.fieldKey.id,
                    value: control.value.fieldKey.value,
                });
            }
        });

        if (fieldsValues.length) {
            return this.getUniqueValues(fieldsValues);
        } else {
            return null;
        }
    }

    // TODO return type string or string[]
    getDecodedValue(encodedValue: string): any {
        return JSON.parse(decodeURIComponent(escape(this.windowRef.nativeWindow.atob(encodedValue))));
    }

    private getUniqueValues(fieldsValues: KeyValuePair[]): KeyValuePair[] {
        const arrayWithUniqueValues = [];

        fieldsValues.forEach((value) => {
            if (
                !arrayWithUniqueValues.find((item) => {
                    return item.key === value.key && item.value === value.value;
                })
            ) {
                arrayWithUniqueValues.push(value);
            }
        });
        return arrayWithUniqueValues;
    }
}
